import { useRef } from 'react';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';

interface Options {
  itemCount: number;
  firstPageSize: number;
  hasMorePages: boolean;
}

export const useScrollTopOnTruncatedList = ({
  itemCount,
  firstPageSize,
  hasMorePages
}: Options): void => {
  const handledRef = useRef(false);
  const isRestoreNavRef = useRef<boolean | null>(null);

  if (isRestoreNavRef.current === null) {
    isRestoreNavRef.current =
      typeof window !== 'undefined' && !!window.isPopState;
  }

  useIsomorphicLayoutEffect(() => {
    if (handledRef.current || typeof window === 'undefined') return;

    const feedWasLost =
      isRestoreNavRef.current && hasMorePages && itemCount <= firstPageSize;

    if (!feedWasLost) {
      handledRef.current = true;
      return;
    }

    const doc = document.documentElement;
    const atBottom = doc.scrollHeight - window.innerHeight - window.scrollY < 4;

    if (atBottom && window.scrollY > 0) {
      window.scrollTo(0, 0);
    }

    if (itemCount > 0) {
      handledRef.current = true;
    }
  }, [itemCount, firstPageSize, hasMorePages]);
};
